<template>
    <section class="relative px-4 py-14 pt-8 pb-8 mx-auto max-w-screen-2xl md:py-28 md-max:pb-20 md:pt-8 sm:px-10 lg:px-8" id="the-products">
        <SectionOverlaySubscriptionOverlay v-if="subscriptionOverlay"/>
       <div :class="{'blur pointer-events-none': subscriptionOverlay}">
        <div class="font-bold text-center text-38 text-lifeboost-orange-200 font-ww-medium" v-html="mainHeading .split('!')[0] || mainHeading"></div>
        
        <div class="mx-auto mt-10 max-w-screen-lg font-bold text-center lg:px-32 md:mt-24 title-mushroom font-ww-medium text-lifeboost-gray-lighter" v-html="subHeading"></div>

        <div class="mt-12 text-center leading-46 md:mt-16 md:px-10 text-40 font-ww-medium text-lifeboost-gray-lighter" v-html="discountText"></div>

        <div class="grid grid-cols-12 mt-10 md:mt-24 lg:gap-x-24 md:gap-x-8 lg:mb-12">
            <div class="col-span-12 lg:col-span-6 md-max:-mx-2">
                <nuxt-img sizes="xs:272px sm:392px md:638px lg:416px xl:450px 2xl:520px"
                    :src="productImageSrc" :alt="productImageAlt" width="845" height="741" format="webp" loading="lazy"></nuxt-img>
            </div>

            <div class="col-span-12 mx-auto mt-10 lg:col-span-6 md:mx-0 md:mt-0">
                <div class="space-y-12 md:space-y-12">
                    <div v-for="(item, index) in items" :key="index" class="flex gap-x-4 md:gap-x-6">
                        <div>
                            <nuxt-img :src="item.imgSrc" :alt="item.imgAlt" width="47" height="47" format="webp" loading="lazy"></nuxt-img>
                        </div>
                        <div class="w-full leading-41 text-28 font-ww-medium text-lifeboost-gray-lighter">
                            <div v-html="item.content"></div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap gap-y-4 gap-x-8 justify-center items-center py-4 pt-16 md:my-4 lg:justify-start">
                    <div class="-mt-1 text-42 text-lifeboost-gray-lighter">
                        <span class="pr-2 line-through font-ww-light" v-html="originalPrice"></span>
                        <strong class="font-ww-medium" v-html="discountedPrice"></strong>
                    </div>
                    <div class="flex items-center px-5 py-3 text-2xl text-white rounded-full bg-lifeboost-blue-300 font-ww-medium" v-html="saveText"></div>
                </div>

                <div class="pt-4 lg:max-w-2xl lg:pr-12">
                    <div class="flex justify-center lg:justify-start">
                        <button @click="addToCart" class="flex items-center w-full bnt-icon !px-12">
                            <span class="flex items-center" v-html="buttonText"></span>
                            <svg class="relative top-0.5 ml-4 w-8 sm:w-auto" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="38px" height="31px" viewBox="0 0 38 31">
                                <path fill-rule="evenodd" fill="rgb(255, 255, 255)" d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z"></path>
                            </svg>
                        </button>
                    </div>

                    <div class="flex flex-wrap gap-x-6 gap-y-6 justify-center mt-5 md:mt-4 md:px-4 lg:justify-center">
                        <div class="flex gap-x-3 items-center" v-for="(checkItem, index) in checkItems" :key="index">
                            <div>
                                <nuxt-img :src="checkItem.imgSrc" :alt="checkItem.imgAlt" class="pt-1" width="34" height="34" format="webp" loading="lazy"></nuxt-img>
                            </div>
                            <div class="leading-8 text-30 text-lifeboost-orange-dark font-ww-medium" v-html="checkItem.text"></div>
                        </div>
                    </div>

                    <div class="mt-12 md:mt-20 md:px-0">
                        <div class="text-33 text-lifeboost-gray-lighter font-ww-medium" v-html="refillText"></div>
                        <div class="mt-6 text-xl leading-8 md:leading-10 md:text-23 md:mt-8 text-lifeboost-gray-lighter font-ww-medium md:font-ww-regular" v-html="refillDetails"></div>
                    </div>
                </div>
            </div>
        </div>
       </div>
    </section>
</template>

<script setup>

const props = defineProps({
    subscriptionOverlay: {
        type: Boolean,
        default: false
    },
    mainHeading: {
        type: String,
        default: "END OF SUMMER SALE"
    },
    subHeading: {
        type: String,
        default: "Get All-Day Energy and Focus With the Power of Healthy, Low-Acid Coffee Upgraded with High-Potency Real Mushrooms"
    },
    discountText: {
        type: String,
        default: "Get <strong>72% Off</strong> the Cognition Coffee Starter Kit - Ends Soon!"
    },
    originalPrice: {
        type: String,
        default: "$214"
    },
    discountedPrice: {
        type: String,
        default: "$59"
    },
    saveText: {
        type: String,
        default: "SAVE $155 TODAY"
    },
    buttonText: {
        type: String,
        default: "Get started"
    },
    refillText: {
        type: String,
        default: "Refill ships in 30 days"
    },
    refillDetails: {
        type: String,
        default: "Three days before your next billing and shipment, we'll send you a reminder email. Your order includes three bags of Lifeboost Cognition Mushroom Coffee. Your first order is $59, all future automatic orders are only $69. You can easily adjust or cancel your subscription at any time."
    },
    productImageSrc: {
        type: String,
        default: '/assets/images/product1112.jpg'
    },
    productImageAlt: {
        type: String,
        default: 'product with gift'
    },
    items: {
        type: Array,
        default: () => [
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<span class="font-ww-regular">2X 12 oz. Bags of Lifeboost Cognition Coffee</span> <strong class="font-ww-medium">($96.66 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Bonus Bag of Lifeboost Cognition Coffee <strong>($48.33 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Shipping <strong>($10.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Coffee with Bonus Coffee Perks <strong>($20.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Toxin Guide <strong>($12.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Coffee Spoon <strong>($15.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Healthy Coffee Recipe Book <strong>($12.00 Value)</strong>',
            },
        ]
    },
    checkItems: {
        type: Array,
        default: () => [
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                text: "30-Day Returns",
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                text: "Free Shipping",
            }
        ]
    },
    products: {
        type: Array,
        default: () => [
            {id:'42133448425532', qty: 1, price: 59.00 , title: 'Cognition Mushroom Ground coffee', selling_plan: 2052063292},
            {id:'42133501018172', qty: 1, price: 0.00 , title: 'Copper Lifeboost Coffee Scoops', selling_plan: null},
            {id:'42239840190524', qty: 1, price: 0.00 , title: 'Bonus Coffee Perks', selling_plan: null},
            {id:'42120155168828', qty: 1, price: 0.00 , title: 'The Ultimate Toxin-Free Living Guide - Digital eBook', selling_plan: null},
            {id:'39411358498876', qty: 1, price: 0.00 , title: '100 Espresso Recipes From Around The World - Digital Recipe eBook', selling_plan: null},
        ]
    },
    discountCodes: {
        type: String,
        default: "CRM-FS,CRM-DISCOUNT"
    },
    productHandle: {
        type: String,
        default: "cognition-mushroom-ground-coffee-copy"
    }
});
const sellingPlanId = await getSellingPlan(props.productHandle, '1 month subscription');
const cart = useCart();

function addToCart() {
    props.products.forEach(product => {
        if (product.selling_plan) product.selling_plan = sellingPlanId;
        cart.add(product);
    });

    cart.checkout(`?discount=${props.discountCodes}`, true);
}

onMounted(() => {
    trackAxonViewItem(props.products);
})

defineBuilderComponent({
    friendlyName: "Title Descriptions Price",
    inputs: [
        { name: "mainHeading", type: "richText", defaultValue: "END OF SUMMER SALE" },
        { name: "subHeading", type: "richText", defaultValue: "Get All-Day Energy and Focus With the Power of Healthy, Low-Acid Coffee Upgraded with High-Potency Real Mushrooms" },
        { name: "discountText", type: "richText", defaultValue: "Get <strong>72% Off</strong> the Cognition Coffee Starter Kit - Ends Soon!" },
        { name: "originalPrice", type: "string", defaultValue: "$173.85" },
        { name: "discountedPrice", type: "string", defaultValue: "$49" },
        { name: "saveText", type: "string", defaultValue: "SAVE $124 TODAY" },
        { name: "buttonText", type: "string", defaultValue: "Get started" },
        { name: "refillText", type: "richText", defaultValue: "Refill ships in 30 days" },
        { name: "refillDetails", type: "richText", defaultValue: "Three days before your next billing and shipment, we'll send you a reminder email. Your order includes three bags of Lifeboost Cognition Mushroom Coffee. Your first order is $49, all future automatic orders are only $59. You can easily adjust or cancel your subscription at any time." },
        { name: "productImageSrc", type: "file", allowedFileTypes: ["jpeg", "jpg", "png", "webp"], defaultValue: "/assets/images/product1112.jpg" },
        { name: "productImageAlt", type: "string", defaultValue: "product with gift" },
        {
            name: "items",
            type: "list",
            subFields: [
                { name: "imgSrc", type: "file", allowedFileTypes: ["jpeg", "jpg", "png", "webp"], defaultValue: "/assets/images/check122.png" },
                { name: "imgAlt", type: "string", defaultValue: "checkbox" },
                { name: "content", type: "richText", defaultValue: '<span class="font-ww-regular">2X 12 oz. Bags of Lifeboost Cognition Coffee</span> <strong class="font-ww-medium">($69.90 Value)</strong>' },
            ],
            defaultValue: [
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<span class="font-ww-regular">2X 12 oz. Bags of Lifeboost Cognition Coffee</span> <strong class="font-ww-medium">($69.90 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Bonus Bag of Lifeboost Cognition Coffee <strong>($34.95 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Shipping <strong>($10.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Coffee with Bonus Coffee Perks <strong>($20.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Toxin Guide <strong>($12.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Coffee Spoon <strong>($15.00 Value)</strong>',
            },
            {
                imgSrc: '/assets/images/check122.png',
                imgAlt: 'checkbox',
                content: '<strong>FREE</strong> Healthy Coffee Recipe Book <strong>($12.00 Value)</strong>',
            },
            ]
        },
        {
            name: "checkItems",
            type: "list",
            subFields: [
                { name: "imgSrc", type: "file", allowedFileTypes: ["jpeg", "jpg", "png", "webp"], defaultValue: "/assets/images/check122.png" },
                { name: "imgAlt", type: "string", defaultValue: "checkbox" },
                { name: "text", type: "richText", defaultValue: "30-Day Returns" },
            ],
            defaultValue: [
                {
                    imgSrc: "/assets/images/check122.png",
                    imgAlt: "checkbox",
                    text: "30-Day Returns"
                },
                {
                    imgSrc: "/assets/images/check122.png",
                    imgAlt: "checkbox",
                    text: "Free Shipping"
                }
            ]
        },
        {
            name: "products",
            type: "list",
            subFields: [
                { name: "id", type: "string", defaultValue: "42133448425532" },
                { name: "qty", type: "number", defaultValue: 1 },
                { name: "price", type: "number", defaultValue: 59.00 },
                { name: "title", type: "string", defaultValue: "Cognition Mushroom Ground coffee" },
                { name: "selling_plan", type: "string", defaultValue: "2052063292" },
            ],
            defaultValue: [
                {id:'42133448425532', qty: 1, price: 59.00 , title: 'Cognition Mushroom Ground coffee', selling_plan: '2052063292'},
                {id:'42133501018172', qty: 1, price: 0.00 , title: 'Copper Lifeboost Coffee Scoops', selling_plan: null},
                {id:'42239840190524', qty: 1, price: 0.00 , title: 'Bonus Coffee Perks', selling_plan: null},
                {id:'42120155168828', qty: 1, price: 0.00 , title: 'The Ultimate Toxin-Free Living Guide - Digital eBook', selling_plan: null},
                {id:'39411358498876', qty: 1, price: 0.00 , title: '100 Espresso Recipes From Around The World - Digital Recipe eBook', selling_plan: null},
            ]
        },
        { name: "productHandle", type: "string", defaultValue: "cognition-mushroom-ground-coffee-copy" },
        { name: "discountCodes", type: "string", defaultValue: "CRM-FS,CRM-DISCOUNT" },
    ],
});
</script>
